import { ResetPasswordForm } from "@/components/auth/auth-forms";

export function ResetPasswordPage() {
  return <ResetPasswordForm />;
}
